import React, {useCallback, useState} from 'react';

import {useAdminAccessRight} from 'src/hooks/access-rights';

import Button from '@pb/kit-component-button';
import {Dialog} from '@pb/kit-component-dialog-v2';

import {NewAccessTermModal} from './new-access-term-modal';

type Props = {
    accountId: number,
    onCreated: () => void,
};

export const NewAccessTermBtn: React.FC<Props> = ({accountId, onCreated}) => {
    const [shown, setShown] = useState(false);
    const [busy, setBusy] = useState(false);

    const onClose = useCallback(() => {
        if (!busy) {
            setShown(false);
        }
    }, [busy]);

    const onSuccess = useCallback(() => {
        setBusy(false);
        setShown(false);
        onCreated();
    }, [onCreated]);

    const {
        canCreateAccountProducts,
    } = useAdminAccessRight();

    return (
        canCreateAccountProducts(accountId) && (
            <>
                <Button variant="Type.PRIMARY" onClick={() => setShown(true)}>Add New Term</Button>
                <Dialog
                    shown={shown}
                    setShown={value => {
                        if (!value) {
                            onClose();
                        }
                    }}
                    wrapperProps={{style: {width: 550}}}>
                    <NewAccessTermModal
                        accountId={accountId}
                        onBusyChange={setBusy}
                        onClose={onClose}
                        onCreated={onSuccess}
                    />
                </Dialog>
            </>
        )
    );
};
